import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { DetailsOfaComponent } from '../../features/details-ofa/details-ofa.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as data from '../../features/list-ofa.json';
import { Title } from '@angular/platform-browser';
import { FullscreenModeService } from '../../../../../core/services/fullscreen-mode.service';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { AppService } from '../../../../../core/services/app.service';
import { LocalStorageService } from 'ngx-webstorage';
import { EventEmitterService } from '../../../../../core/services/event-emitter.service';
import { SharedDataService } from '../../../../../core/services/shared-data.service';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { GlobalVariableService } from 'src/app/core/services/global-variable.service';
import swal from "sweetalert2";
import { ExcelService } from 'src/app/core/services/excel.service';
// import * as isThisHour from 'date-fns/is_this_hour/index';
import * as FileSaver from 'file-saver';
import { AgentsOfaService } from '../../../campagne/agents-ofa/data-access/agent-ofa.service';
import { DecimalPipe } from '@angular/common';
import {AppConfigService} from "../../../../../core/services/config.service";


@Component({
  selector: 'app-mes-propositions',
  templateUrl: './mes-propositions.component.html',
  styleUrls: ['./mes-propositions.component.css']
})
export class MesPropositionsComponent implements OnInit, OnDestroy {
  public ICpage: any;
  public AMpage: any;
  public OEpage: any;

  public _direction: any;
  public _structure: any;
  public _classification: any;
  public nom_prenoms: string;
  public matricule: string;
  public campagne_id: any;

  public listIC: any = [];
  public listAM: any = [];
  public listOE: any = [];

  public listDR: any = [];
  public listStructureJ: any = [];
  public listClassificationJ: any = [];

  public p = 1;

  public clickEventSubscription: Subscription;
  public filterForm: FormGroup;
  public submitted = false;
  public isLoadingXls: boolean = false;
  public isLoading: boolean = false;
  public listSolde: any;
  public selectedTab: any;
  public detailsSolde: any;
  public soldeArray: any = [];
  public listStructure: any = [];

    public statistics: any;

  public key = 'id'; // set default
  public reverse = false;
  public loaderText: any;
  public filter: any;
  public listOfa: any = (data as any).default;
  public response: any;
  public idStructure = 0;
  public activeTab: any;
  public activeId: any = 1;
  public user: any;
  public dataApi;
  public API_URL: any;
  public modifier_show: boolean;
  public voir_show: boolean;
  public libelle_menu = 'Mes_propositions'
  constructor(
    private formBuilder: FormBuilder,
    private title: Title,
    private fullscreenService: FullscreenModeService,
    public configService: AppConfigService,
    public decimalPipe: DecimalPipe,
    private modalService: NgbModal,
    private loadingBar: LoadingBarService,
    private _service: AppService,
    private variable: GlobalVariableService,
    private excelService: ExcelService,
    private storage: LocalStorageService,
    private sharedService: SharedDataService,
    private toastrService: ToastrService
  ) {
    this.clickEventSubscription = this.sharedService.getClickEventRefreshTablePropositions().subscribe(() => {
      this.pageCallback();
    });
  }

  public async exportXls(): Promise<void> {
    this.isLoading = true;
    this.toastrService.info('La génération de l\'export est en cours')
    const data = {'campagne_ofa_id': this.storage.retrieve('idCampagneOfaSelected')}
    try {
      const res = await this._service.postData(`capital-humain/agents/export-campagne/all`, data).toPromise();
      this.isLoading = false;
      this.excelService.exportAsExcelFile(res?.data, 'Liste des agents');
    } catch (error) {
      this.toastrService.error(error.error.message);
    } finally {
      this.isLoading = false;
      this.loadingBar.stop();
    }
    }

  public ngOnInit(): void {
    this.API_URL = this.configService.get('HOST_API_ONLINE');
    this.user = JSON.parse(this.variable.getUser());
    this.title.setTitle('Mes propositions | HR Performance');
    this.pageCallback();

    // this._service.getData(`gestion-ofas/directeurs/${this.GetStorage('idCampagneOfaSelected')}/structure-of-directeur`).subscribe((res) => { this.listStructureJ = res.data, this._structure = this.optionId(this.listStructureJ, this.listStructureJ[this.listStructureJ?.length - 1]?.id) });
    // this._service.getData(`gestion-ofas/responsable-ofas/${this.storage.retrieve('idCampagneOfaSelected')}/mes-soldes`).subscribe((res) => this.detailsSolde = res.data);
    this.filterForm = this.formBuilder.group({
      structure_id: [''],
      statut: [''],
      matricule: [''],
    });
  }

  public ngOnDestroy(): void {
    this.clickEventSubscription.unsubscribe();
  }

  public clickRefresh(){
    this.clearValue();
    this.pageCallback();

  }

  public optionId(data, value): number {
    return data.find(option => option.id === value)
  }


  public GetStorage(key): any {
    const _data = this.storage.retrieve(key);
    if (_data) {
      try {
        return JSON.parse(_data);
      } catch (error) {
        console.error('Error parsing user JSON:', error);
      }
    } else {
      return;
    }
  }

    public getStatFormat(data): any {
    return this.decimalPipe.transform(data, '1.2-2');
  }

  public getStatusClasses(statut: string): { [key: string]: boolean } {
    return {
      'badge-info': statut === 'initialisé' || statut === 'soumis' || statut === 'appliqué' || statut === 'analysé',
      'badge-danger': statut === 'archivé' || statut === 'retourné',
      'badge-success': statut === 'arbitré' || statut === 'traité',
      'badge-warning': statut === 'en attente',
      'badge-valide': statut === 'validé',
      'badge-effectue': statut === 'effectué' || statut === 'démarré',
      'badge-accepte': statut === 'accepté',
      'badge-planifie': statut === 'planifié',
      'badge-approuve': statut === 'approuvé',
      'badge-revus': statut === 'revu',
      'badge-soumis': statut === 'soumis',
      'badge-100': statut !== 'planifié'
    };
  }

  public getDisplayStatut(statut: string): string {
    return statut != null ? (statut === 'en attente' ? statut : `${statut}e`) : '--' ;
  }

  public thousandSeparator(value) {
    const spaces = value => String(value)
      .replace(
        /(?!^)(?=(?:\d{3})+$)/g,
        ' '
      );
      return value != null ? spaces(value) : '--';
  }


  public checkShow(statut): boolean {
    return statut === 'archivé' ? true : false;
  }

  // Post all FILTER
  public filtr(): void {
    this.pageCallback()
    this.sharedService.sendRefreshTableSoldesProp();
  }

  public pageCallback(): void {
    const data = {
      nom_prenoms: this.nom_prenoms,
      matricule: this.matricule,
      campagne_ofa_id: this.storage.retrieve('idCampagneOfaSelected'),
    }
    this.loadingBar.start();
    this._service
      .postData(`gestion-ofas/responsable-ofas/mes-fiches-ofa?page=${this.p}`, data)
      .subscribe({
        next: (res: any) => {
          this.loadingBar.stop();
          // this.toastrService.success(res.message);
          this.response = res['data'];
          this.statistics = this.response;
          this.listIC = this.response.data['IC'].data;
          this.ICpage = this.response.data['IC'];
          this.listAM = this.response.data['AM'].data;
          this.AMpage = this.response.data['AM'];
          this.listOE = this.response.data['OE'].data;
          this.OEpage = this.response.data['OE'];
          // this.detailsSolde = this.response?.data?.soldes;
          this.sharedService.sendRefreshTableSoldesProp();
        },
        error: (error) => {
          this.loadingBar.stop();
          this.toastrService.error(error.error.message);
        }
      })
  }

  public clearValue() {
    this.nom_prenoms = "";
    this.matricule = "";
  }

  public onPageChange(event) {
    this.p = event;
    this.pageCallback()
  }


  // Get logs
  public getLogs(): void {
    this._service.getData('menus/' + this.libelle_menu + '/getUserInteractions').subscribe(data => { })
  }


  public get f() { return this.filterForm.controls; }

  // Submit Form
  public onSubmit(): void {
    this.submitted = true;
    if (this.filterForm.invalid) {
      return;
    }
    const data = {
      'structure_id': '',
      'statut': '',
      'matricule': '',
    };
  }


  public ouvrirOfa(data, typevue): void {
    const modalRef = this.modalService.open(DetailsOfaComponent,{ size: 'lg', windowClass: 'modal-adaptive' });
    modalRef.componentInstance.ofa = data;
    modalRef.componentInstance.vue = 'propositions';
    modalRef.componentInstance.type = typevue;
  };


  // Get all structure
  public getAllStructure(): void {
    this.loadingBar.start();
    this._service.getData('structure/mes_structures').subscribe((data: {}) => {
      this.loadingBar.stop();
      this.response = data;
      this.listStructure = this.response.data;
    });
  }

  //Get soumettre en masse
  public SoumettreMasse(): void {
   const data = {
      // fiche_ofa_id : id,
      campagne_ofa_id: this.storage.retrieve('idCampagneOfaSelected'),
    }
    swal.fire({
      title: `Êtes-vous sûr?`,
      text: 'Vous allez soumettre en masse toutes les propositions !!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#FD7E14',
      cancelButtonColor: '#d33',
      cancelButtonText: 'Non, Annuler!',
      confirmButtonText: 'Oui, soumettre!'
    }).then((result) => {
      if (result.value) {
        this.loadingBar.start();
        this.loaderText = 'Soumission en cours';
        this._service.postData(`gestion-ofas/responsable-ofas/soumettre-masse-proposition`, data)
          .subscribe(
            res => {
              if (res.error === false) {
                this.loadingBar.stop();
                this.toastrService.success(res.message);
                this.pageCallback();
                // this.sharedService.sendRefreshTableAnalyse();
              } else {
                this.toastrService.error(res.message);
                this.loadingBar.stop();
              }
            }, err => {
              this.loadingBar.stop();
              this.toastrService.error(err.error.message);
            }
          );
      }
    });
  }

  public exportData(data): void {
    const arrayAgent = [];
    for (var i = 0; i < data?.length; i++) {
      arrayAgent.push(
        {
          'Matricule': data[i].matricule,
          'Nom': data[i].nom,
          'Prénoms': data[i].prenom,
          'Categorie': data[i].categorie,
          'Salaire brut': data[i].salaire_brut,
          'Salaire net': data[i].salaire_net,
          'Appréciation EIA': data[i].appreciation_eia,
          'Proposition promotion': data[i].promo_categorie,
          'Proposition augmentation': data[i].aug_montant,
          'Taux gratification': data[i].gratif_taux,
          'Proposition gratification': data[i].gratif_montant,
          'Proposition bonus': data[i].bonus_montant,
          'Révision': data[i].revision,
          'Statut': data[i].statut,
        }
      )
    }
    this.excelService.exportAsExcelFile(arrayAgent, 'Liste des agents');
  }

  //Export global mes propostions
  public exportGlobal() {
    this.isLoadingXls = true;
    const header = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
      Authorization: 'Bearer ' + this.variable.getAccessToken(),
    }

    const requestOptions = {
      headers: new Headers(header),
    };
    // this.loadingBar.start();
    this.toastrService.info('La génération de l\'export est en cours');
    return fetch(this.API_URL + `gestion-ofas/directeurs/${this.storage.retrieve('idCampagneOfaSelected')}/export-recap-solde`, requestOptions)
      .then(res => res.blob()) // extract binary blob from response
      .then(blob => {
        this.isLoadingXls = false;
        // Download blob with file-saver
        FileSaver.saveAs(blob, "Export_global_mes_propositions.xlsx");
      })
      .catch((err) => { console.error('Excel download failed', err); this.isLoadingXls = false;});
  }

  public tabChange(evt): void {
    this.selectedTab = evt.nextId;
    localStorage.removeItem('activeId');
    localStorage.setItem('activeId', evt.nextId)
  }

}
